var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarRepair({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400.9,322.8l-13.8-82.7c-3-18.2-18.6-31.5-37.1-31.5H192c-18.5,0-34.1,13.2-37.1,31.4l-13.8,82.8 c-22.6,1.2-40.8,19.6-40.8,42.5v108.7h37.9c0,20.9,17,37.9,37.9,37.9s37.9-17,37.9-37.9h113.8c0,20.9,17,37.9,37.9,37.9 c20.9,0,37.9-17,37.9-37.9h37.9v-109C441.6,342.2,423.5,323.8,400.9,322.8z M166.7,436.1c-15.7,0-28.4-12.7-28.4-28.4 s12.7-28.4,28.4-28.4s28.4,12.7,28.4,28.4S182.4,436.1,166.7,436.1z M179.5,322.4l12.5-75.9l157.7-0.3l12.7,76.1H179.5z  M375.3,436.1c-15.7,0-28.4-12.7-28.4-28.4s12.7-28.4,28.4-28.4s28.4,12.7,28.4,28.4S391,436.1,375.3,436.1z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.6,56.9H206.1C191.4,23.4,158.1,0,119.3,0C80.4,0,47.1,23.4,32.4,56.9h86.8l19,37.9l-19,37.9H32.4 c14.6,33.5,47.9,56.9,86.8,56.9c38.9,0,72.2-23.4,86.8-56.9h235.6c21,0,37.9-17,37.9-37.9S462.6,56.9,441.6,56.9z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarRepair);
export default __webpack_public_path__ + "static/media/car-repair.e54584a8754e4f2dbc39b2291e8c4bde.svg";
export { ForwardRef as ReactComponent };